// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QvzJe","fullView":"styles_fullView__14Hll"};